<div class="welcome-screen">
  <div class="team-board" *ngIf="noticeBoardItems.length > 0" ng-cloak>
    <div class="labels box-shadow">
      <h1 class="title team-alerts">
        team alerts
      </h1>
      <div *ngFor="let notice of noticeBoardItems" class="alert-container">
        <div class="alert-card">
          <div class="alert-title">{{notice.title}}</div>
          <div class="alert-content" [innerHTML]="notice.content"></div>
          <a class="alert-link" (click)="openModal(modal, notice)">
            read more
          </a>
          <hr class="alert-card-divider">
          <!-- <div class="alert-card-name">
            <svg id="Group_170" data-name="Group 170" xmlns="http://www.w3.org/2000/svg" width="15.958" height="20.076"
              viewBox="0 0 15.958 20.076">
              <path id="Path_236" data-name="Path 236"
                d="M7.478,15.768c-1.222.611-1.684,1.312-1.684,1.857s.462,1.246,1.684,1.857a10.927,10.927,0,0,0,4.751.974,10.926,10.926,0,0,0,4.751-.974c1.222-.611,1.684-1.312,1.684-1.857s-.462-1.246-1.684-1.857a10.926,10.926,0,0,0-4.751-.974A10.927,10.927,0,0,0,7.478,15.768Zm-.691-1.381a12.448,12.448,0,0,1,5.441-1.137,12.449,12.449,0,0,1,5.441,1.137c1.386.693,2.538,1.794,2.538,3.239s-1.151,2.546-2.538,3.239A12.449,12.449,0,0,1,12.229,22a12.448,12.448,0,0,1-5.441-1.137C5.4,20.171,4.25,19.071,4.25,17.626S5.4,15.08,6.788,14.387Z"
                transform="translate(-4.25 -1.925)" fill-rule="evenodd" />
              <path id="Path_237" data-name="Path 237"
                d="M12.14,3.794A3.346,3.346,0,1,0,15.486,7.14,3.346,3.346,0,0,0,12.14,3.794ZM7.25,7.14a4.89,4.89,0,1,1,4.89,4.89A4.89,4.89,0,0,1,7.25,7.14Z"
                transform="translate(-4.161 -2.25)" fill-rule="evenodd" />
            </svg>
            {{notice.createdBy}}
            <div class="alert-card-date">{{notice.startDate}}</div>
          </div> -->
          <div class="alert-card-name">
            <!-- Conditionally render SVG based on notice.CreatedBy using *ngIf -->
            <ng-container *ngIf="notice.createdBy === 'alert'; else noticeBoardSvg">
              <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22.304"
              height="18.9"
              viewBox="0 0 24.704 22.729"
            >
              <path
                id="Path_227"
                data-name="Path 227"
                d="M12.362,4.142a2.272,2.272,0,0,1,3.632.411L20.87,13a2.272,2.272,0,0,1-1.461,3.351L7.346,19.111l-3.408-5.9Z"
                transform="translate(-0.286 -2.634)"
                fill="none"
                stroke="#000"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_228"
                data-name="Path 228"
                d="M7.409,17.49l-2.84-4.919a1.7,1.7,0,0,0-2.952,1.7l2.84,4.919a1.7,1.7,0,1,0,2.952-1.7Z"
                transform="translate(-0.633 -1.504)"
                fill="none"
                stroke="#000"
                stroke-linecap="round"
                stroke-width="1.5"
              />
              <path
                id="Path_229"
                data-name="Path 229"
                d="M13.422,16l2.439,4.225a1.7,1.7,0,0,1-.624,2.328h0a1.7,1.7,0,0,1-2.328-.624L9.9,16.707"
                transform="translate(0.524 -0.922)"
                fill="none"
                stroke="#000"
                stroke-linecap="round"
                stroke-width="1.5"
              />
              <path
                id="Path_230"
                data-name="Path 230"
                d="M18.294,5.088l.416-1.552"
                transform="translate(1.667 -2.617)"
                fill="none"
                stroke="#000"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_231"
                data-name="Path 231"
                d="M20.294,8.366l1.552.416"
                transform="translate(1.939 -1.96)"
                fill="none"
                stroke="#000"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
            </svg>
            </ng-container>
          
            <!-- Else block for 'notice board' -->
            <ng-template #noticeBoardSvg>
              <svg xmlns="http://www.w3.org/2000/svg" 
              style="width: 24px; height: 20px;vertical-align: middle;overflow: hidden;" 
              viewBox="0 0 1024 1024" 
              version="1.1">
              <path 
              d="M859.354 255.953H717.847L534.921 73.026c-0.409-0.41-0.829-0.802-1.255-1.184a30.918 30.918 0 0 0-3.474-2.694c-0.177-0.119-0.357-0.231-0.536-0.345a31.2 31.2 0 0 0-2.24-1.31c-0.03-0.016-0.063-0.03-0.093-0.046-0.462-0.241-0.93-0.469-1.4-0.685-9.147-4.192-19.913-3.702-28.678 1.478a31.073 31.073 0 0 0-6.167 4.787l-0.009 0.01-182.917 182.916H163.887c-55.781 0-101 45.219-101 101v501.341c0 55.78 45.219 101 101 101h695.468c55.78 0 101-45.22 101-101V356.953c-0.001-55.781-45.22-101-101.001-101zM513 138.79l117.163 117.163H395.837L513 138.79z m383.174 710.432c0 24.301-19.699 44-44 44H172c-24.301 0-44-19.699-44-44V363c0-24.301 19.699-44 44-44h73.105l-43.714 43.714c-12.107 12.107-12.107 31.735 0 43.842s31.736 12.107 43.843 0L332.79 319h360.419l87.557 87.557c12.106 12.106 31.735 12.106 43.842 0 12.107-12.107 12.107-31.736 0.001-43.842L780.895 319h71.279c24.301 0 44 19.699 44 44v486.222z"/>
              <path d="M737.072 512h-449c-17.686 0-32.023 14.337-32.023 32.023 0 17.686 14.337 32.022 32.023 32.022h449c17.687 0 32.023-14.337 32.023-32.022 0.001-17.686-14.336-32.023-32.023-32.023zM737.072 703.754h-449c-17.686 0-32.023 14.337-32.023 32.023 0 17.686 14.337 32.022 32.023 32.022h449c17.687 0 32.023-14.337 32.023-32.022 0.001-17.686-14.336-32.023-32.023-32.023z"/></svg>
            </ng-template>
          
            <!-- Display the createdBy value -->
            {{ notice.createdBy }}
          </div>
          

        </div>
      </div>
    </div>
  </div>
  <div class="stats" ng-cloak>
    <!--<div class="divider"></div>-->
    <div class="letter-dashboard box-shadow">
      <letter-dashboard></letter-dashboard>
    </div>
    <!--<div class="divider"></div>-->
    <!--<div class="horizontal-divider"></div>-->
    <div class="team-stats box-shadow">
      <h1 class="title">
        team’s completed letters
      </h1>
      <div class="stat">
        <span  [ngbPopover]="'The number of letters completed by all users in the last 7 days. The arrow shows whether this was more or fewer letters than the previous 7 days.'" 
        triggers="hover"  class="number">{{teamStats.lastWeekAnswered}}</span>
        <span class="blue-horizontal-line" *ngIf="teamStats.lastWeekChanged === '0'">-</span>
        <img class="arrow" *ngIf="teamStats.lastWeekChanged !== '0'"
             [src]="getChangeArrowIcon(teamStats.lastWeekChanged)"  alt="last week completed output rate change direction" />
        <h3>last week</h3>
      </div>
      <div class="stat">
        <span [ngbPopover]="'The number of letters completed by all users in the last month. The arrow shows whether this was more or fewer letters than the previous month.'" 
        triggers="hover" class="number">{{teamStats.lastMonthAnswered}}</span>
        <span class="blue-horizontal-line" *ngIf="teamStats.lastMonthChanged === '0'">-</span>
        <img class="arrow" *ngIf="teamStats.lastMonthChanged !== '0'"
             [src]="getChangeArrowIcon(teamStats.lastMonthChanged)"  alt="last month completed output rate change direction" />
        <h3>last month</h3>
      </div>
      <div class="stat left-divided">
        <span [ngbPopover]="'The total number of letters completed by all users - all time. '"
        triggers="hover" class="number">{{teamStats.totalAnswered}}</span>
        <h3>total letters</h3>
      </div>
    </div>
  </div>
</div>
<ng-template #modal let-c="close" let-d="dismiss">
  <!-- <div class="modal-container grey">
    <div class="close-icon black" (click)="d('Cross click')"></div>
    <div class="content">
      <h3>{{selectedAlert.name}}</h3>
      <p [innerHTML]="selectedAlert.instructions | safe: 'html'"></p>
    </div>
  </div> -->
  <div class="modal-container">
    <div class="close-icon white" (click)="d('Cross click')"></div>
    <div class="content">
      <h2>{{selectedNotice.title}}</h2>
      <hr>
      <p [innerHTML]="selectedNotice.content | safe: 'html'"></p>

    </div>
  </div>
</ng-template>
